import {
  api_GlobalToken,
  api_AccessToken,
  flow_get_tokens_global,
  err,
  api_ApiKey

} from "../stores/sagas";
import { fork, take, put, join, select, call } from "redux-saga/effects";
import { createAction, createReducer } from "redux-act";

export const post_postal = createAction("post_postal");

export const fetchingFalse = createAction("fetchingFalse");
export const loadingFalse = createAction("loadingFalse");
export const loadingDataFalse = createAction("loadingDataFalse");

export const failure_postal = createAction("failure_postal");

export const postal = createReducer(
  {
    [post_postal]: (state, payload) => {
      const newState = Object.assign({}, state, {});
      newState.isLoading = true;
      return newState;
    },
    [fetchingFalse]: (state, payload) => {
      const newState = Object.assign({}, state, { ...payload.data });
      newState.isFetching = false;
      return newState;
    },
    [loadingDataFalse]: (state, payload) => {
      const newState = Object.assign({}, state, { ...payload.data });
      newState.isLoading = false;
      return newState;
    },
    [loadingFalse]: (state, payload) => {
      const newState = Object.assign({}, state, {});
      newState.isLoading = false;
      return newState;
    },
  },
  {
    isLoading: false,
    isFetching: true,
    postal: [],
  }
);



export function* flow_post_postal() {
  while (true) {
    const { payload } = yield take(post_postal);

    const { data, error } = yield call(
      api_ApiKey,
      `postal`,
      "get",
      payload.data
    );
    if (!error) {
      yield put(loadingFalse({ data }));

      !payload.page || payload.page(data);
    } else {
      yield put(loadingFalse({ error }));
      !payload.toast || payload.toast(err(error));
    }
  }
}
